module.exports = __webpack_public_path__ + "static/media/bfOnline.3a658942.svg";